<template>
  <!-- 优惠券列表 -->
  <div class="coupons">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['优惠券', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
          v-if="buttonVisibility.add"
          >添加</el-button
        >
        <el-button
          type="danger"
          @click="handleDel()"
          v-if="buttonVisibility.delete"
        >删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">领取类型：</label>
        <el-select
          placeholder="领取类型"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.getType"
        >
          <el-option
            v-for="(item, index) in getTypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <label class="label">范围规则：</label>
        <el-select
          placeholder="范围规则"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.range"
        >
          <el-option
            v-for="(item, index) in rangeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <label class="label">规则类型：</label>
        <el-select
          placeholder="规则类型"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.ruleType"
        >
          <el-option
            v-for="(item, index) in ruleTypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <label class="label">状态：</label>
        <el-select
          placeholder="状态"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="优惠券编码"
          v-model="searchForm.couponCode"
        >
        </el-input>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="优惠券名称"
          v-model="searchForm.couponName"
        >
        </el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)" v-if="buttonVisibility.search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      @selection-change="selectionChangeTable"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="couponCode"
        show-overflow-tooltip
        label="编码"
      >
      </el-table-column>
      <el-table-column
        prop="couponName"
        align="center"
        show-overflow-tooltip
        label="名称"
      >
      </el-table-column>
      <el-table-column
        prop="couponsNumber"
        label="数量"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="typetitle"
        label="渠道类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="receivingType"
        label="领取类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sceneName"
        label="范围类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="SceneSon"
        label="范围"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="coupontype"
        label="优惠类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="startingTime"
        label="开始时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="endTime"
        label="结束时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == '上架'"
            >已上架</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.status == '下架'"
            >已下架</el-tag
          >
          <el-tag type="info" v-else-if="scope.row.status == ''">已作废</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            class="my-table-button"
            plain
            @click="couponDetail(scope.row)"
            v-if="buttonVisibility.details"
            >查看</el-button
          >
          <el-button
            type="success"
            v-show="scope.row.status == '下架'"
            class="my-table-button"
            plain
            @click="changeStatus(scope.row, 1)"
            v-if="buttonVisibility.shelf"
            >上架</el-button
          >
          <!-- <el-button
            type="danger"
            v-show="scope.row.status == '下架'"
            class="my-table-button"
            plain
            @click="changeStatus(scope.row, 2)"
            >删除</el-button
          > -->
          <el-button
            type="warning"
            v-show="scope.row.status == '上架'"
            class="my-table-button"
            plain
            @click="changeStatus(scope.row, 0)"
            v-if="buttonVisibility.unshelf"
            >下架</el-button
          >
          <el-button
            type="danger"
            v-show="scope.row.status != ''"
            class="my-table-button"
            plain
            @click="changeStatus(scope.row, 3)"
            v-if="buttonVisibility.invalid"
            >作废</el-button
          >
          <el-button
            type="success"
            class="my-table-button"
            plain
            @click="serviceCondition(scope)"
            v-if="buttonVisibility.usage"
            >使用情况</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 添加优惠券 -->
    <el-drawer
      title=""
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">新增优惠劵</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="120px"
            :rules="formRule"
            ref="addForm"
          >
            <el-form-item label="领券开始时间" prop="start">
              <el-date-picker
                v-model="addForm.start"
                type="datetime"
                style="width: 100%"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择开始日期"
                @change="handleEndTimeChange"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="领券截止时间" prop="end">
              <el-date-picker
                v-model="addForm.end"
                type="datetime"
                style="width: 100%"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择截至日期"
                @change="handleEndTimeChange"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="优惠劵类型" prop="getType">
              <el-select
                placeholder="请选择领取类型"
                style="width: 100%"
                v-model="addForm.getType"
              >
                <el-option
                  v-for="(item, index) in getList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="订单赠送-件数"
              prop="orderNum"
              v-show="addForm.getType == 4"
              class="el-form-required-true"
            >
              <el-input-number
                v-model="addForm.orderNum"
                :min="1"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="订单赠送-满额"
              prop="orderPrice"
              v-show="addForm.getType == 5"
              class="el-form-required-true"
            >
              <el-input-number
                v-model="addForm.orderPrice"
                :min="1"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              v-show="addForm.getType == 7"
              label="赠送条件"
              prop="howBill"
              class="el-form-required-true"
            >
              <span>第 </span>
              <el-input-number
                v-model="addForm.howBill"
                :controls="false"
                :min="1"
                style="width: 50px"
              >
              </el-input-number>
              <span> 单，满 </span>
              <el-input-number
                v-model="addForm.orderPrice"
                :min="1"
                style="width: 100px"
                :controls="false"
              >
              </el-input-number>
              <span> 元</span>
            </el-form-item>
            <!-- <el-form-item label="客户类型" prop="range">
              <el-checkbox-group v-model="addForm.range" style="width: 100%">
                <el-checkbox
                  v-for="(item, index) in rangeTypeList"
                  :label="item.TypeID"
                  :key="index"
                >
                  {{ item.clienttype }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item> -->
            <el-form-item label="区域控销" prop="rangeType">
              <el-select
                placeholder="请选择使用规则"
                style="width: 100%"
                v-model="addForm.rangeType"
              >
                <el-option label="无限制" value="0"></el-option>
                <el-option label="白名单" value="1"></el-option>
                <el-option label="黑名单" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="选择区域"
              prop="areaValue"
              v-show="addForm.rangeType != 0"
              class="el-form-required-true"
            >
              <div class="area">
                <div class="area_List">
                  <el-tag
                    v-for="(item, index) in areaList"
                    :key="index"
                    closable
                    @close="areaspan(index)"
                    type="success"
                    effect="dark"
                    :disable-transitions="false"
                    class="my-el-tag"
                    style="margin-bottom: 5px"
                    >{{ item.地址 }}
                  </el-tag>
                </div>
                <el-button
                  type="primary"
                  @click="addAear"
                >增加区域</el-button>
              </div>
            </el-form-item>
            <!-- <el-form-item label="客户控销" prop="customerLimit">
              <el-select
                v-model="addForm.customerLimit"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option label="无限制" value="0"></el-option>
                <el-option label="指定白名单" value="1"></el-option>
                <el-option label="指定黑名单" value="2"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item
              v-if="addForm.customerLimit != 0"
              label="选择客户分组"
              prop="customerGroup"
            >
              <el-select
                ref="groupListSelect"
                v-model="addForm.customerGroup"
                placeholder="请选择"
                style="width: 100%"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in groupList"
                  :key="item.GroupId"
                  :label="item.GroupName"
                  :value="item.GroupId"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="范围类型" prop="ruleType">
              <el-select
                placeholder="请选择范围类型"
                style="width: 100%"
                v-model="addForm.ruleType"
              >
                <el-option
                  v-for="(item, index) in ruleList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="活动分类"
              v-show="addForm.ruleType == 1"
              prop="ruleName"
              class="el-form-required-true"
            >
              <el-input
                v-model="addForm.ruleName"
                :readonly="true"
                :controls="false"
                @click.native="addRuleClass(1)"
                style="width: 100%"
                placeholder="单击选择"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="活动品牌"
              v-show="addForm.ruleType == 2"
              prop="rulebrand"
              class="el-form-required-true"
            >
              <!-- <el-input clearable v-model="addForm.rulebrand" :controls="false" placeholder="请输入品牌编号"></el-input> -->
              <el-select
                placeholder="可选择/搜索"
                v-model="addForm.rulebrand"
                filterable
                remote
                :remote-method="getBrandData"
              >
                <el-option
                  v-for="item in brandData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="活动商品"
              v-show="addForm.ruleType == 3"
              prop="ruleGood"
              class="el-form-required-true"
            >
              <el-input
                @click.native="addRuleClass(2)"
                v-model="addForm.ruleGood"
                :controls="false"
                style="width: 100%"
              ></el-input>
              <div class="sub_title" v-show="goodDrugShow">
                <p>商品：{{ indetaDetail.sub_title }}</p>
                <p>生产公司：{{ indetaDetail.drug_factory }}</p>
                <p>规格：{{ indetaDetail.drug_spec }}</p>
                <p>中包装：{{ indetaDetail.min_package }}</p>
                <p>库存：{{ indetaDetail.stock_quantity }}</p>
              </div>
            </el-form-item>
            <el-form-item
              label="商品分组"
              v-show="addForm.ruleType == 4"
              prop="group"
              class="el-form-required-true"
            >
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addForm.group"
              >
                <el-option
                  v-for="(item, index) in goodsGroup"
                  :key="index"
                  :label="item.GroupName"
                  :value="item.GroupId"
                ></el-option>
              </el-select>
            </el-form-item>

            <!-- 选择专区 -->
            <el-form-item
              label="活动专区"
              v-show="addForm.ruleType == 5"
              prop="expert"
              class="el-form-required-true"
            >
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="addForm.expert"
              >
                <el-option
                  v-for="item in expertList"
                  :key="item.value"
                  :label="item.title"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="使用规则" prop="setRuleType">
              <el-select
                placeholder="请选择使用规则"
                style="width: 100%"
                v-model="addForm.setRuleType"
              >
                <el-option
                  v-for="(item, index) in setRuleTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="规则-满额"
              prop="fullred"
              v-show="addForm.setRuleType == 1 || addForm.setRuleType == 9"
              class="el-form-required-true"
            >
              <el-input-number
                v-model="addForm.fullred"
                style="width: 100%"
                :min="1"
              ></el-input-number>
            </el-form-item>
            <!-- <el-form-item
              label="规则-减额"
              prop="fulladd"
              v-show="addForm.setRuleType != 9 || addForm.setRuleType != 11"
              class="el-form-required-true"
            >
              <el-input-number
                v-model="addForm.fulladd"
                style="width: 100%"
                :min="1"
              ></el-input-number>
            </el-form-item> -->
            <el-form-item
              label="规则-减额"
              prop="fulladd"
              v-show="addForm.setRuleType != 9"
              class="el-form-required-true"
            >
              <el-input-number
                v-model="addForm.fulladd"
                style="width: 100%"
                :min="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="规则-折扣"
              prop="discount"
              v-show="addForm.setRuleType == 9"
              class="el-form-required-true"
            >
              <el-input-number
                v-model="addForm.discount"
                style="width: 100%"
                :min="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="规则-折扣最高优惠金额"
              prop="discountMax"
              v-show="addForm.setRuleType == 9"
              class="el-form-required-true"
            >
              <el-input-number
                v-model="addForm.discountMax"
                style="width: 100%"
                :min="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="规则-满减"
              prop="discount"
              v-show="addForm.setRuleType == 11"
              class="el-form-required-true"
            >
              <el-input-number
                v-model="addForm.discount"
                style="width: 100%"
                :min="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="规则-满减最高优惠金额"
              prop="discountMax"
              v-show="addForm.setRuleType == 11"
              class="el-form-required-true"
            >
              <el-input-number
                v-model="addForm.discountMax"
                style="width: 100%"
                :min="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="优惠券名称" prop="couponName">
              <el-input
                clearable
                placeholder="优惠券名称"
                v-model="addForm.couponName"
              ></el-input>
            </el-form-item>
            <el-form-item label="优惠券总数" prop="couponSum">
              <el-input-number
                v-model="addForm.couponSum"
                :min="1"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              v-show="showGetNum"
              label="用户可领取次数"
              prop="getNum"
            >
              <el-input-number
                v-model="addForm.getNum"
                :min="1"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="优惠券生效时间" prop="couponstart">
              <el-date-picker
                v-model="addForm.couponstart"
                type="datetime"
                style="width: 100%"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择开始日期"
                @change="handleEndTimeChange"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="优惠券截止时间" prop="couponend">
              <el-date-picker
                v-model="addForm.couponend"
                type="datetime"
                style="width: 100%"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择截至日期"
                @change="handleEndTimeChange"
              >
              </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="支付方式" prop="">
              <el-checkbox-group v-model="addForm.checkedPayType">
                <el-checkbox
                  v-for="item in payTypeList"
                  :label="item.PayId"
                  :key="item.PayId"
                  >{{ item.PayType }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item> -->
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button
          type="primary"
          @click="submitForm"
        >确定</el-button>
        <el-button
          type="info"
          @click="resetForm"
        >取消</el-button>
      </div>
    </el-drawer>

    <!-- 添加区域信息 -->
    <el-dialog
      title="区域列表"
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleClose"
    >
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入区域名称"
            v-model="searchWhere"
          >
          </el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getDoodGood"
            >搜索</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-circle-check"
            @click="detarRegion"
            >确定</el-button
          >
        </template>
      </search-bar>
      <el-table
        :data="goodList"
        stripe
        border
        tooltip-effect="dark"
        @row-dblclick="rowClickArea"
        @selection-change="selectionChange"
        style="width: 100%; height: 100%; overflow: auto"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage1 - 1) * pageSize1 + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column type="selection" align="center" width="55">
        </el-table-column>
        <el-table-column
          align="center"
          prop="区域编号"
          show-overflow-tooltip
          label="区域编号"
        >
        </el-table-column>
        <el-table-column
          prop="地址"
          align="center"
          show-overflow-tooltip
          label="地址"
        >
        </el-table-column>
        <el-table-column
          prop="省市区"
          label="省市区"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :allPage="allPage1"
        :pageSize="pageSize1"
        :currIndex="currPage1"
        @hanCurrChange="hanCurrChange1"
        layout="total, prev, pager, next, jumper"
      ></pagination>
    </el-dialog>

    <!-- 添加商品分类信息 -->
    <el-dialog
      title="商品分类(二级分类)"
      :visible.sync="goodVisible"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入编号/名称"
            v-model="searchForm2.name"
          >
          </el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="seach2"
            v-if="buttonVisibility.search"
            >搜索</el-button
          >
        </template>
      </search-bar>
      <el-table
        :data="goodListData"
        stripe
        border
        @row-click="rowClick"
        tooltip-effect="dark"
        style="width: 100%; height: 100%; overflow: auto"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage2 - 1) * pageSize2 + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="分类"
          show-overflow-tooltip
          label="分类"
        >
        </el-table-column>
        <el-table-column
          prop="父类名"
          label="父类名"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <pagination
        :allPage="allPage2"
        :pageSize="pageSize2"
        :currIndex="currPage2"
        @hanCurrChange="hanCurrChange2"
        layout="total, prev, pager, next, jumper"
      ></pagination>
    </el-dialog>

    <!-- 添加独立商品信息 -->
    <el-dialog
      title="商品列表"
      :visible.sync="inDegoodVisible"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入编号/名称"
            v-model="searchForm3.name"
          >
          </el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="seach3"
            v-if="buttonVisibility.search"
            >搜索</el-button
          >
        </template>
      </search-bar>
      <el-table
        :data="inGoodListData"
        stripe
        border
        @row-click="inRowClick"
        tooltip-effect="dark"
        style="width: 100%; height: 100%; overflow: auto"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage3 - 1) * pageSize3 + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="keyid"
          show-overflow-tooltip
          label="商品编号"
        >
        </el-table-column>
        <el-table-column
          prop="sub_title"
          label="名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="drug_spec"
          label="规格"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="min_package"
          label="中包装"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="big_package"
          label="件数量"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="drug_factory"
          label="生厂场地"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="stock_quantity"
          label="库存"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="price_ck"
          label="参考价"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <pagination
        :allPage="allPage3"
        :pageSize="pageSize3"
        :currIndex="currPage3"
        @hanCurrChange="hanCurrChange3"
        layout="total, prev, pager, next, jumper"
      ></pagination>
    </el-dialog>
  </div>
</template>

<script>

//表单验证
import { mustFill } from "@/mixins/data/valid.js";
import { mapState } from 'vuex';

export default {
  name: "coupons",
  data() {
    return {
      /**账号信息 */
      entId: "",

      /**表格数据 */
      //序号	操作	编码	名称	数量	渠道类型	领取类型
      //范围类型	范围	优惠类型	开始时间	结束时间	状态
      tableData: [
        {
          code: "编码",
          name: "名称",
          num: "数量",
          deviceType: "渠道类型",
          getType: "领取类型",
          rangeTpe: "范围类型",
          range: "范围",
          couponType: "优惠类型",
          begin: "开始时间",
          end: "结束时间",
          status: "状态",
        },
      ],
      /**搜索表单 */
      searchForm: {
        getType: "99", //领取类型
        range: "99", //范围类型
        ruleType: "99", //使用规则
        status: "99", //状态
        couponCode: "", //优惠码
        couponName: "", //优惠劵名称
      },
      searchForm2: {
        name: "",
      },
      searchForm3: {
        name: "",
      },
      goodList: [],
      searchWhere: "", //搜素区域
      goodListData: [],
      inGoodListData: [],
      selectedListTable: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      currPage1: 1,
      pageSize1: 10,
      allPage1: 0,
      currPage2: 1,
      pageSize2: 10,
      allPage2: 0,
      currPage3: 1,
      pageSize3: 10,
      allPage3: 0,
      addDrawer: false /**新增drawer */,
      dialogVisible: false,
      goodVisible: false,
      inDegoodVisible: false,
      goodDrugShow: false,
      /**表单数据 */
      addForm: {
        getType: "", // 优惠券类型
        orderNum: "", // 订单-件数
        orderPrice: "", // 订单-满额和收单赠送满足金额，都用的这个值
        range: [], // 客户类型
        rangeType: "0", // 客户区域
        areaValue: [], // 地区值
        areaLabel: [], //地区名称
        customerLimit: "0", //客户控销
        customerGroup: [], //客户列表id
        ruleType: "", // 范围类型
        couponName: "", // 优惠券名称
        couponSum: "", // 优惠券数量
        getNum: 1, //用户可领取次数
        start: this.getDefaultStartTime(), // 活动开始时间
        end: this.getDefaultEndTime(), // 活动结束时间
        couponstart: this.getDefaultStartTime(), // 优惠券开始时间
        couponend: this.getDefaultEndTime(), // 优惠券结束时间
        setRuleType: "", // 使用规则
        ruleClass: "", // 活动分类
        ruleName: "", // 活动分类名称
        rulebrand: "", // 活动品牌
        expert: "", //选中专区
        ruleGood: "", // 活动商品
        fullred: "", // 规则满额
        fulladd: "", // 规则减额
        discount: 100, // 折扣
        discountMax: "", // 折扣最高优惠金额
        /**赠送条件 */
        howBill: 1, //满足订单数量
        group: "", //商品分组
        checkedPayType: [], //选中的支付方式
      },
      groupList: [], //客户分组列表
      formRule: {
        getType: [mustFill],
        orderNum: [this.getTypeFill(4)],
        orderPrice: [this.getTypeFill(5)],
        range: [mustFill],
        rangeType: [mustFill],
        areaValue: [this.areaMustFill()],
        customerLimit: [mustFill],
        customerGroup: [mustFill],
        ruleType: [mustFill],
        couponName: [mustFill],
        couponSum: [mustFill],
        getNum: [mustFill],
        start: [mustFill],
        end: [mustFill],
        couponend: [mustFill],
        couponstart: [mustFill],
        setRuleType: [mustFill],
        ruleName: [this.ruleTypeFill(1)],
        rulebrand: [this.ruleTypeFill(2)],
        ruleGood: [this.ruleTypeFill(3)],
        expert: [this.ruleTypeFill(5)],
        fullred: [this.fullredFill()],
        fulladd: [this.fulladdFill()],
        discount: [this.discountFill()],
        discountMax: [this.discountFill()],
        howBill: [mustFill],
        group: [
          {
            validator: (rule, value, callback) => {
              if (this.addForm.ruleType == 4) {
                if (!value) {
                  callback(new Error("请选择商品分组"));
                  return;
                }
                callback();
              } else {
                callback();
              }
            },
          },
        ],
      },
      getTypeList: [
        {
          value: "99",
          label: "全部",
        },
        {
          value: "0",
          label: "领卷中心",
        },
        {
          value: "2",
          label: "新人",
        },
        {
          value: "3",
          label: "订单-无限制",
        },
        {
          value: "4",
          label: "订单-件数限制",
        },
        {
          value: "5",
          label: "订单-满额限制",
        },
      ],

      rangeList: [
        {
          value: "99",
          label: "全部",
        },
        {
          value: "0",
          label: "全部商品",
        },
        {
          value: "1",
          label: "分类商品",
        },
        {
          value: "2",
          label: "品牌商品",
        },
        {
          value: "3",
          label: "独立商品",
        },
      ],
      ruleTypeList: [
        {
          value: "99",
          label: "全部",
        },
        {
          value: "0",
          label: "无门槛",
        },
        {
          value: "1",
          label: "满减",
        },
      ],
      statusList: [
        {
          value: "99",
          label: "全部",
        },
        {
          value: "1",
          label: "上架中",
        },
        {
          value: "0",
          label: "未上架",
        },
      ],
      deviceList: [],
      getList: [],
      ruleList: [],
      setRuleTypeList: [],
      rangeTypeList: [],
      selectedList: [],
      areaList: [],
      sendID: "",
      indetaDetail: {
        sub_title: "", //商品
        drug_factory: "", //生产公司
        drug_spec: "", //规格
        min_package: "", //中包装
        stock_quantity: "", //库存
      },
      isSelDataOkRep: false,

      /**品牌数据相关 */
      brandData: [],

      /**商品分组 */
      goodsGroup: [],

      /**支付方式 */
      payTypeList: [], //支付方式列表

      /**自定义专区 */
      expertList: [], //列表
    };
  },
  mounted() {
    this.entId = window.localStorage.getItem("entId");
    this.handleRefresh();
  },
  computed: {
    /**是否显示可领取次数输入框 */
    showGetNum() {
      console.log(this.addForm.getType);
      if (this.addForm.getType == 0) {
        return true;
      } else if (this.addForm.getType == 7) {
        return false;
      } else {
        return false;
      }
    },

    // 按钮权限
    ...mapState(['buttonPermissions']),
    buttonVisibility() {
      const buttonsLimit = this.buttonPermissions?.['优惠券列表'] || [] ;
      console.log('优惠券列表buttonsLimit', buttonsLimit);
      return {
        add: buttonsLimit.includes('添加'),
        delete: buttonsLimit.includes('删除'),
        search: buttonsLimit.includes('搜索'),
        details: buttonsLimit.includes('查看'),
        shelf: buttonsLimit.includes('上架'),
        unshelf: buttonsLimit.includes('下架'),
        invalid: buttonsLimit.includes('作废'),
        usage: buttonsLimit.includes('使用情况'),
      }
    },
  },
  methods: {
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData(1);
      let timer = setTimeout(() => {
        this.getcouponTypeData();
        this.getRanGeData();
        this.getsetRuleTypeData();
        this.getGroupList(); //获取客户列表
        this.getGoodsGroup();
        this.getPayType();
        clearTimeout(timer);
        timer = null;
      }, 500);

      let timer2 = setTimeout(() => {
        this.getDoodGood();
        this.getGoodListData();
        this.getinGoodListData();
        this.getClientData();
        this.getBrandData();
        this.getExpertList();
        clearTimeout(timer2);
        timer2 = null;
      }, 1000);
    },
    // 获取开始时间
    getDefaultStartTime() {
      return this.setToStartTime(new Date())
    },
    setToStartTime(date) {
      date.setHours(0, 0, 0, 0)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    // 获取截止时间
    getDefaultEndTime() {
      return this.setToEndTime(new Date())
    },
    setToEndTime(date) {
      date.setHours(23, 59, 59, 999)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    handleEndTimeChange(value) {
      if (value) {
        this.addForm.end = this.setToEndOfDay(new Date(value))
        this.addForm.start = this.setToStartTime(new Date(value))
        this.addForm.couponstart = this.setToStartTime(new Date(value))
        this.addForm.couponend = this.setToEndTime(new Date(value))

      }
    },

    // 搜索分类商品
    seach2() {
      this.getGoodListData();
    },
    // 搜索独立商品
    seach3() {
      this.getinGoodListData();
    },
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "Pc_GetCoupon",
        couponCode: this.searchForm.couponCode,
        couponName: this.searchForm.couponName,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
        sltGZ: this.searchForm.ruleType,
        sltSB: "10006", //默认10006，平台类型
        sltLQ: this.searchForm.getType,
        sltCJ: this.searchForm.range,
        status: this.searchForm.status,
      };
      let proc = "Pc_Coupon"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.tableData = [];
          // console.log(res);
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取区域数据
    getDoodGood() {
      let data = {
        type: "RegionListN",
        PageIndex: this.currPage1,
        PageSize: this.pageSize1,
        strWhere: this.searchWhere,
        xentId: "",
      };
      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodList = res.content;
            this.allPage1 = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取商品分类
    getGoodListData() {
      let data = {
        type: "CategrysListHG",
        PageIndex: this.currPage2,
        PageSize: this.pageSize2,
        strWhere: this.searchForm2.name,
      };
      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodListData = res.content;
            this.allPage2 = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取商品列表
    getinGoodListData() {
      let data = {
        type: "GoodsList",
        PageIndex: this.currPage3,
        PageSize: this.pageSize3,
        strWhere: this.searchForm3.name,
      };
      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.inGoodListData = res.content;
            this.allPage3 = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    // 查看优惠券详情
    couponDetail(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(
          JSON.stringify({ couponId: row.couponCode })
        );
      } else {
        prams = row;
      }
      this.$router.push({
        path: "couponDetail",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },

    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**当前页改变 */
    hanCurrChange1(val) {
      this.currPage1 = val;
      this.getDoodGood();
    },

    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getGoodListData();
    },
    /**当前页改变 */
    hanCurrChange3(val) {
      this.currPage3 = val;
      this.getinGoodListData();
    },
    // 点击选中分类事件
    addRuleClass(i) {
      if (i == 1) {
        this.goodVisible = true;
      } else {
        this.inDegoodVisible = true;
      }
    },
    // 行选中事件分类商品
    rowClick(row) {
      this.addForm.ruleName = row.分类;
      this.addForm.ruleClass = row.keyid;
      this.goodVisible = false;
    },
    // 行选中事件独立商品
    inRowClick(row) {
      this.addForm.ruleGood = row.keyid;
      this.goodDrugShow = true;
      this.indetaDetail = row;
      this.inDegoodVisible = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },

    selectionChange(section) {
      this.selectedList = section;
    },

    // 数据单行双击选择
    rowClickArea(row, isSelDataOk) {
      for (let i = 0; i < this.areaList.length; i++) {
        if (this.areaList[i].keyid == row.keyid) {
          if (isSelDataOk === true) {
            this.isSelDataOkRep = true;
          } else {
            this.$message({
              message: "选择的数据已在列表中",
              type: "warning",
            });
          }
          return;
        }
      }
      this.areaList.push(row);
      // this.addForm.areaValue = this.areaList.map((item) => item.keyid).join();
      let arr1 = [];
      let arr2 = [];
      this.areaList.forEach((item) => {
        arr1.push(item.keyid);
        arr2.push(item.Area);
      });
      // this.addForm.areaValue = arr1.join()
      // this.addForm.areaLabel = arr2.join()

      this.addForm.areaValue = arr1;
      this.addForm.areaLabel = arr2;
      this.dialogVisible = false;
    },
    detarRegion() {
      this.selectedList.forEach((item) => {
        this.rowClickArea(item, true);
      });
      if (this.isSelDataOkRep) {
        this.$message({
          message: "选择的数据已在列表中",
          type: "warning",
        });
        this.isSelDataOkRep = false;
      }
    },
    // 获取类型控制
    getTypeFill(type) {
      return {
        validator: (rule, value, callback) => {
          if (this.addForm.getType == type) {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
      };
    },
    // 区域控制
    areaMustFill() {
      return {
        validator: (rule, value, callback) => {
          if (this.addForm.rangeType != "0") {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
      };
    },
    // 范围类型控制
    ruleTypeFill(type) {
      return {
        validator: (rule, value, callback) => {
          if (this.addForm.ruleType == type) {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
      };
    },
    // 使用规则控制 满额
    fullredFill() {
      return {
        validator: (rule, value, callback) => {
          if (this.addForm.setRuleType == 1 || this.addForm.setRuleType == 9) {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
      };
    },
    // 使用规则控制 额度
    fulladdFill() {
      return {
        validator: (rule, value, callback) => {
          if (this.addForm.setRuleType != 9) {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
      };
    },

    /**获取客户分组 */
    getGroupList() {
      let data = {
        entId: this.entId,
        status: "2",
        searchVal: "", //关键字
        pageIndex: 1,
        pageSize: 999,
      };

      this.$request({
        url: "Member/GetMemberGroup",
        method: "post",
        data,
      })
        .then((res) => {
          this.groupList = res.list;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 使用规则控制 折扣
    discountFill() {
      return {
        validator: (rule, value, callback) => {
          if (this.addForm.setRuleType == 9) {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
      };
    },
    areaspan(index) {
      this.areaList.splice(index, 1);
      let arr1 = [];
      let arr2 = [];
      // this.addForm.areaValue = this.areaList.map((item) => item.keyid).join();
      this.areaList.forEach((item) => {
        arr1.push(item.keyid);
        arr2.push(item.Area);
      });
      // this.addForm.areaValue = arr1.join()
      // this.addForm.areaLabel = arr2.join()

      this.addForm.areaValue = arr1;
      this.addForm.areaLabel = arr2;
    },
    addAear() {
      this.dialogVisible = true;
    },
    /**新增优惠券 */
    handleAdd() {
      this.addDrawer = true;
    },

    /**提交新增表单 */
    submitForm() {
      let sceneName = ""; //临时变量
      if (this.addForm.ruleType == 0) {
        this.sendID = "";
      } else if (this.addForm.ruleType == 1) {
        this.sendID = this.addForm.ruleClass;
      } else if (this.addForm.ruleType == 2) {
        this.sendID = this.addForm.rulebrand;
      } else if (this.addForm.ruleType == 3) {
        // 独立商品
        this.sendID = this.addForm.ruleGood;
        sceneName = this.indetaDetail.sub_title;
      } else if (this.addForm.ruleType == 4) {
        this.sendID = this.addForm.group;
        // 商品名称过滤出来
        this.goodsGroup.forEach((item) => {
          if (item.GroupId == this.addForm.group) {
            sceneName = item.GroupName;
          }
        });
      } else if (this.addForm.ruleType == 5) {
        this.sendID = this.addForm.expert;
      }

      this.$refs["addForm"].validate((valid) => {
        console.log(valid);
        if (valid) {
          // 如果选择的是无门槛，则this.addForm.fullred赋值为0
          if (this.addForm.setRuleType == 0) {
            this.addForm.fullred = 0;
          }

          // 过滤选中分组的名称
          // let groupName = this.groupList.map(item => {
          //   if (this.addForm.customerGroup.indexOf(item.GroupId) > -1) {
          //     return item.GroupName
          //   }
          // })

          // let data = {
          //   type: "PC_AddCoupon",
          //   typeCoding: '10006',//平台类型，不要了，默认1通用
          //   receivingType: this.addForm.getType,
          //   couponName: this.addForm.couponName,
          //   couponsNumber: this.addForm.couponSum,
          //   singleNumber: this.addForm.getNum,
          //   couponCode: "",
          //   SceneCoding: this.addForm.ruleType,
          //   SceneId: this.sendID,
          //   SceneName: sceneName,//选中商品范围的名称，例如：单品的名称、分组的名称
          //   AllAmount: this.addForm.orderPrice,// 订单-满额和收单赠送满足金额，都用的这个值
          //   Num: this.addForm.orderNum,//订单-件数
          //   types: this.addForm.setRuleType,
          //   ProductCode: "", // 赠品
          //   fullAmount: this.addForm.fullred, // 满额
          //   deduction: this.addForm.fulladd, // 满减
          //   maximumAmount: "0",
          //   discount: parseFloat(this.addForm.discount) / 100, // 折扣
          //   MaxPreferentialAmount: this.addForm.discountMax, // 折扣最高优惠金额
          //   number: "0", //件 数
          //   cxdatemin: this.addForm.start,
          //   cxdatemax: this.addForm.end,
          //   startingTime: this.addForm.couponstart,
          //   endTime: this.addForm.couponend,
          //   customertype: this.addForm.range.join(),
          //   qykzlx: this.addForm.rangeType,// 区域控制类型 0 不拦截 1 白名单 2 黑名单
          //   qykzbh: this.addForm.rangeType != 0 ? this.addForm.areaValue : "",
          //   qykzname: this.addForm.rangeType != 0 ? this.addForm.areaLabel : "",
          //   frequency: this.addForm.howBill, //满足订单数量
          //   pclx: this.addForm.customerLimit,//客户拦截类型 0 不拦截 1 白名单 2 黑名单
          //   pckh: this.addForm.customerLimit != 0 ? this.addForm.customerGroup.join(',') : '', //客户分组编号
          //   pckhname: this.addForm.customerLimit != 0 ? groupName.join(',') : '',
          // };

          let CouponLimit = [];

          // 将区域添加到数组中
          this.addForm.areaValue.forEach((item, index) => {
            CouponLimit.push({
              LimitType: "Area",
              Limit: this.addForm.rangeType,
              LimitCode: item,
              LimitName: this.addForm.areaLabel[index],
            });
          });

          // 将客户类型添加到数组中 客户类型 药店、连锁什么的
          for (let i = 0; i < this.rangeTypeList.length; i++) {
            if (this.addForm.range.indexOf(this.rangeTypeList[i].TypeID) > -1) {
              CouponLimit.push({
                LimitType: "ClientType",
                Limit: this.addForm.rangeType, // 选中的客户类型都为生效的
                LimitCode: this.rangeTypeList[i].TypeID,
                LimitName: this.rangeTypeList[i].clienttype,
              });
            }
          }

          // 客户分组 测试客户分组一 等等
          for (let i = 0; i < this.groupList.length; i++) {
            if (
              this.addForm.customerGroup.indexOf(this.groupList[i].GroupId) > -1
            ) {
              CouponLimit.push({
                LimitType: "Client",
                Limit: this.addForm.rangeType, // 选中的客户类型都为生效的
                LimitCode: this.groupList[i].GroupId,
                LimitName: this.groupList[i].GroupName,
              });
            }
          }

          // 支付方式
          for (let i = 0; i < this.payTypeList.length; i++) {
            if (
              this.addForm.checkedPayType.indexOf(this.payTypeList[i].PayId) >
              -1
            ) {
              CouponLimit.push({
                LimitType: "PayType",
                Limit: this.addForm.rangeType, // 选中的客户类型都为生效的
                LimitCode: this.payTypeList[i].PayId,
                LimitName: this.payTypeList[i].PayType,
              });
            }
          }

          let data = {
            PromCoupons: {
              StartDate: this.addForm.start, // 活动开始时间
              EndDate: this.addForm.end, // 活动结束时间
              Qykzlx: this.addForm.rangeType, // 区域控制类型 0 不拦截 1 白名单 2 黑名单
              ExcludeType: this.addForm.customerLimit, //客户拦截类型 0 不拦截 1 白名单 2 黑名单
            },

            CouponsInfo: {
              couponName: this.addForm.couponName, // 优惠券名称
              couponsNumber: this.addForm.couponSum, // 数量
              StartingTime: this.addForm.couponstart, // 开始时间
              EndTime: this.addForm.couponend, // 结束时间
              TypeCoding: "10006", //平台类型，不要了，默认1通用
              ReceivingType: this.addForm.getType, //优惠券类型
              SceneCoding: this.addForm.ruleType, // 范围类型
              AllAmount: this.addForm.orderPrice, //订单-满额和收单赠送满足金额，都用的这个值
              Types: this.addForm.setRuleType, //使用规则
              SceneId: this.sendID, // 商品范围id
              SceneName: sceneName, //选中商品范围的名称，例如：单品的名称、分组的名称
              FullAmount: this.addForm.fullred, // 满额
              Deduction: this.addForm.fulladd, // 满减
              MaxPreferentialAmount: this.addForm.discountMax, // 折扣最高优惠金额
              Discount: parseFloat(this.addForm.discount) / 100, // 折扣
              SingleNumber: this.addForm.getNum,
              Num: this.addForm.orderNum, //订单-件数
              Frequency: this.addForm.howBill, //满足订单数量
            },

            CouponLimit,
          };

          // console.log(data)
          // console.log(JSON.stringify(data))

          this.$request({
            method: "post",
            url: "/Management/CouponAdmin/SaveCouponApi",
            dataType: "json",
            data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
                this.resetForm();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });

          // var proc = "Pc_Coupon"; //存储过程名
          // var type = "ReturnNumber";
          // this.$request({
          //   method: "post",
          //   url:
          //     "coupon/ashx/ReturnJson.ashx?type=" +
          //     type +
          //     "&json=" +
          //     encodeURIComponent(JSON.stringify(data)) +
          //     "&proc=" +
          //     proc,
          //   dataType: "json",
          // })
          //   .then((res) => {
          //     if (res.flag == 0) {
          //       this.$message({
          //         message: "操作成功",
          //         type: "success",
          //       });
          //       this.getTableData();
          //       this.resetForm();
          //     } else {
          //       this.$message({
          //         message: res.message,
          //         type: "error",
          //       });
          //     }
          //   })
          //   .catch((err) => {
          //     window.console.log(err);
          //   });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },

    /**重置表单 */
    resetForm() {
      this.$refs["addForm"].resetFields();
      this.addDrawer = false;
    },
    recursion(list) {
      list = list.split("</option><option");
      list = list.map((item) => {
        let label = item
          .split("'>")[1]
          .split("</option>")[0]
          .replace(/&nbsp;/g, " ");
        let value = item.split("value='")[1].split("'>")[0];
        return { label, value };
      });
      return list;
    },

    // 获取优惠劵类型
    getcouponTypeData() {
      let proc = "Pc_Coupon"; //存储过程名
      let type = "ReturnBox";
      let json = {
        type: "Pc_GetClassType",
        strWhere: "",
        ConfigType: "501",
      };
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(json)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          console.log('优惠券res',res);
          if (res.flag == 0) {
            let list = this.recursion(res.objList);
            this.getList = list;
            this.addForm.getType = list[0].value;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取范围类型
    getRanGeData() {
      let proc = "Pc_Coupon"; //存储过程名
      let type = "ReturnBox";
      let json = {
        type: "Pc_GetClassType",
        strWhere: "",
        ConfigType: "505",
      };
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(json)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            let list = this.recursion(res.objList);
            this.ruleList = list;
            this.addForm.ruleType = list[0].value;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取使用规则
    getsetRuleTypeData() {
      let proc = "Pc_Coupon"; //存储过程名
      let type = "ReturnBox";
      let json = {
        type: "Pc_GetClassType",
        strWhere: "",
        ConfigType: "502",
      };
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(json)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            let list = this.recursion(res.objList);
            this.setRuleTypeList = list;
            console.log(this.setRuleTypeList, "this.setRuleTypeList");
            this.addForm.setRuleType = list[0].value;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取客户类型
    getClientData() {
      let proc = "Proc_Admin_CustomerList"; //存储过程名
      let type = "ReturnList";
      let json = {
        type: "CustomType",
      };
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(json)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.rangeTypeList = res.data;
            // 默认选中第一个客户类型
            if (this.rangeTypeList.length > 0) {
              // 将第一个客户类型的 TypeID 添加到 addForm.range 数组中
              this.addForm.range = [this.rangeTypeList[0].TypeID];
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**获取品牌商品 */
    getBrandData(name) {
      let data = {
        type: "Query_Brand",
        status: 2,
        strWhere: name,
        PageIndex: 1,
        PageSize: 20,
      };
      let proc = "Proc_Admin_Brand"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "brand/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.brandData = res.data.map((item) => ({
              label: item.name,
              value: item.billno,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**获取自定义专区 */
    getExpertList() {
      let data = {
        entId: this.entId,
        navType: "ExpertList",
        status: 2, // 启用状态
      };

      this.$request({
        url: "Navigation/GetNavigationAll",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.expertList = res.list;
          } else {
            this.tableData = [];
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    selectionChangeTable(section) {
      this.selectedListTable = section;
    },
    /**删除 */
    handleDel() {
      let row = {};
      if (this.selectedListTable.length == 1) {
        row = this.selectedListTable[0];
        if (row.status == "下架") {
          this.changeStatus(row, 2);
        } else {
          this.$message({
            message: "优惠券下架才能删除",
            type: "warning",
          });
        }
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
    // 修改优惠券状态
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == 0) {
        msg = "确定下架吗?";
        type = "warning";
      } else if (status == 1) {
        msg = "确定上架吗?";
        type = "success";
      } else if (status == 2) {
        msg = "确定删除吗?";
        type = "error";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            type: "PC_UpStatusCoupon",
            couponCode: row.couponCode,
            status: status,
          };
          let proc = "Pc_Coupon"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "coupon/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },

    /**查看优惠券使用情况 */
    serviceCondition({ row }) {
      // 然后使用本地存储向客户优惠券界面发送事件
      this.$router.push({
        name: "userCoupon",
        params: {
          couponCode: row.couponCode,
        },
      });
    },

    /**获取商品分组功能 */
    getGoodsGroup() {
      let data = {
        type: "GetPromGoodsGroup",
        status: 2,
        strWhere: "",
        PageIndex: 1,
        PageSize: 99,
      };
      let proc = "Proc_PromGoodsGroup"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "prom/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.goodsGroup = res.data;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**获取支付方式 */
    getPayType() {
      this.$request({
        url: "Base/GetEntPayTypeList",
        method: "post",
        data: {
          entId: this.entId,
        },
      })
        .then((res) => {
          if (res.success) {
            this.payTypeList = res.list.map((item) => {
              return {
                PayType: item.PayType,
                PayId: item.PayId + "", //转换为字符串
              };
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.coupons {
  width: 100%;
  height: 100%;
}

.area_List {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.sub_title {
  margin-top: 5px;
  font-size: 12px;
  color: red;
  line-height: 16px;
}
</style>
